import { createFileRoute, redirect } from '@tanstack/react-router';
import CmdLoader from '@commander-services/cmd-loader';
import Layout from '../components/Layout';
import { isLoggedIn } from '../Services/UserService';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    // Unauthenticated users get a single, canonical login route (with its own title) instead of
    // the login form rendered inline by <Layout> on `/`. Authenticated users fall through to the
    // landing loader below, where <Layout> loads the menu and navigates to the first menu item.
    if (!isLoggedIn()) {
      throw redirect({ to: '/login' });
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: IndexRoute,
});

function IndexRoute() {
  // Authenticated landing: <Layout> shows the loader while it resolves the first menu item.
  return <Layout component={CmdLoader} />;
}
